import { useState, useEffect } from 'preact/hooks';
import { authFetch } from '../api/authFetch';

export function useRoles() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAdminContext, setIsAdminContext] = useState(false);
  const [userEmail, setUserEmail] = useState<string | null>(null);

  useEffect(() => {
    const ac = new AbortController();
    authFetch('/api/me/roles', { signal: ac.signal })
      .then((r) => r.ok ? r.json() : null)
      .then((data) => {
        if (data?.roles) setIsAdmin(data.roles.includes('admin'));
        if (data?.email) setUserEmail(data.email);
        if (data?.isAdminContext != null) setIsAdminContext(data.isAdminContext);
      })
      .catch(() => {});
    return () => ac.abort();
  }, []);

  return { isAdmin, isAdminContext, userEmail };
}
